<template>
	<div>
		<div v-for="(group, index) in groups" :key="index">
			<component :is="group.component" :products="group.products" hide-change-buttons />
		</div>

		<div>
			<div class="experience-transportation__button-container" v-if="!isShopUpdatePending">
				<Button class="experience-merch__button button--small" :to="route"> {{ buttonLabel }} </Button>

				<Button class="experience-merch__button button--small" @click.native="removeItems">
					{{ $t('page.shop.experience_builder.merchandise.remove') }}
				</Button>
			</div>

			<div v-else>
				<Spinner />
			</div>
		</div>
	</div>
</template>

<script>
import ExperienceContentTickets from './ExperienceContentTickets.vue';
import ExperienceContentExtra from './ExperienceContentExtra.vue';
import ExperienceContentMerchandise from './ExperienceContentMerchandise.vue';

export default {
	name: 'ExperienceContentPackages',

	components: {
		ExperienceContentTickets,
		ExperienceContentExtra,
		ExperienceContentMerchandise
	},

	props: {
		products: Array,
		route: String,
		buttonLabel: String
	},

	computed: {
		groups() {
			return this.products.reduce((result, product) => {
				const type = product.type.mappedType;
				const index = result.findIndex(r => r.type === type);
				const existingProducts = index > -1 ? result[index].products : [];
				const component = {
					ticket: 'ExperienceContentTickets',
					extras: 'ExperienceContentExtra',
					merchandise: 'ExperienceContentMerchandise'
				}[type];

				const newElement = {
					type,
					component,
					products: [...existingProducts, product]
				};

				if (index === -1) {
					result.push(newElement);
				} else {
					result[index] = newElement;
				}

				return result;
			}, []);
		},

		isShopUpdatePending() {
			return this.$store.getters['shopapi/getIsShopUpdatePending'];
		}
	},

	methods: {
		removeItems() {
			this.$fireErrorEventWithPromis(6001).then(response => {
				this.$store.dispatch('shopapi/removeOptionFromExperienceBuilder', this.products);

				const productsToRemove = [];

				this.products.forEach(product => {
					if (product.type.slug !== 'shipping') {
						const tempData = {
							name: product.type.meta.name,
							price: product.type.price,
							productId: product.type.id,
							amount: product.numproducts,
							shop: this.$store.getters['shopconfig/getData'].titleFull,
							type: product.type.mappedType
						};
						productsToRemove.push(tempData);
					}
				});
				productsToRemove.length &&
					this.removeFromDataLayer({
						products: productsToRemove
					});
			});
		}
	}
};
</script>
